import { AppProviders } from '@app/providers/AppProviders';
import { AppRouter } from '@app/routes/AppRouter';

export const App = () => (
  <AppProviders>
    <AppRouter />
  </AppProviders>
);
